<template>
  <div>
    <div class="flex_vcenter gutter_b_s" v-for="(value, index) in addCoupon" :key="index">
      <!-- <el-select placeholder="搜索优惠券名称" filterable v-model="value.couponId" :disabled="isDetail">
        <el-option v-for="item in couponList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select> -->
      <div>
        <el-popover placement="bottom" :width="300" :disabled="isDetail" trigger="click" ref="storePopover">
          <template #reference>
            <div
              class="flex_vcenter flex_bet coupon-select"
              :style="{ color: isDetail ? '#a8abb2' : '#000', cursor: isDetail ? 'not-allowed' : 'pointer', background: isDetail ? '#f5f7fa' : 'white' }"
            >
              <span class="overflow_text_1" v-if="value.couponId">{{ getCouponName(value.couponId) }}</span>
              <span class="text_label no-select" v-else>优惠券选择</span>
              <img src="/imgs/icon_down.png" />
            </div>
          </template>
          <div>
            <div class="flex_vcenter search_box">
              <el-input class="gutter_r_10" placeholder="搜索优惠券名称" v-model="searchValue" @keyup.enter="toSeach"></el-input>
              <el-button type="primary" @click="toSeach">搜索</el-button>
            </div>
            <div class="coupon-list">
              <div :class="['coupon-data', value.couponId == item.id && 'coupon-data-active']" v-for="(item, i) in searchList" :key="i" @click="setCoupon(item, index)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </el-popover>
      </div>

      <div class="count_zhang">
        <el-input :maxlength="limitNum.length" :disabled="isDetail" placeholder="数量" @keyup="value.number = oninput(value.number, 0)" @blur="inputHandel(value)" v-model="value.number"></el-input>
      </div>
      <div class="gutter_l_s">张</div>
      <el-button link type="primary" class="del-btn" v-if="addCoupon.length > 1 && !isDetail" @click="delBtn(index)">删除 </el-button>
    </div>
    <el-button type="text" v-if="!isDetail" @click="addClick()">添加优惠券</el-button>
  </div>
</template>

<script>
export default {
  name: 'userInfo',
  emits: ['update:Coupons'],
  props: {
    addCoupon: {
      type: Array,
      default: () => {
        return [
          {
            couponId: '',
            number: ''
          }
        ]
      }
    },
    // 外部优惠券列表
    enter_couponList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否可以编辑
    isDetail: {
      type: Boolean,
      default: false
    },
    // 限制数量
    limitNum: {
      type: String,
      default: '300'
    }
  },
  watch: {
    addCoupon: {
      handler(newVal) {},
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      couponList: [],
      searchList: [],
      searchValue: ''
    }
  },
  created() {
    if (this.enter_couponList.length > 0) {
      this.couponList = this.enter_couponList
      this.searchList = this.enter_couponList
    } else {
      this.$common.getCouponList().then(res => {
        this.couponList = res.data || []
        this.searchList = res.data || []
      })
    }
  },
  methods: {
    delBtn(index) {
      this.addCoupon.splice(index, 1)
      this.$emit('update:Coupons', this.addCoupon)
    },
    addClick() {
      this.searchValue = ''
      this.searchList = this.couponList

      let obj = {
        couponId: '',
        number: ''
      }
      this.addCoupon.push(obj)
      this.$emit('update:Coupons', this.addCoupon)
    },
    inputHandel(item) {
      if (Number(item.number) > Number(this.limitNum)) {
        item.number = this.limitNum
      }
    },
    getCouponName(id) {
      let name = ''
      this.couponList.forEach(item => {
        if (item.id == id) {
          name = item.name
        }
      })
      return name
    },
    setCoupon(item, index) {
      this.addCoupon[index].couponId = item.id
      this.$refs.storePopover[index].hide()
    },
    toSeach() {
      this.searchList = this.couponList.filter(item => item.name.indexOf(this.searchValue) > -1)
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.el-select) {
  width: 300px;
}
.del-btn {
  color: #ff4949;
  margin-left: 10px;
}

.coupon-select {
  width: 300px;
  height: 32px;
  padding: 2px 10px;
  border-radius: 4px;
  border: 1px solid #0000001a;
  img {
    width: 20px;
    height: 20px;
  }
}
.coupon-list {
  height: 300px;
  margin-top: 10px;
  overflow-y: auto;
}
.coupon-data {
  margin-right: 4px;
  padding: 10px 5px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: #ffe4cf;
  }
}

.coupon-data-active {
  background: #ffe4cf;
}

.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
